import { useState, useEffect } from 'react';
import { playBeep } from '../../../utils/audio';

export const useEanValidation = (invoiceData, printType) => {
  const [eanInputs, setEanInputs] = useState([""]);
  const [eanValidated, setEanValidated] = useState([false]);

  useEffect(() => {
    if (invoiceData && Array.isArray(invoiceData.content?.products)) {
      setEanInputs(Array(invoiceData.content.products.length).fill(""));
      setEanValidated(Array(invoiceData.content.products.length).fill(false));
    } else {
      setEanInputs([""]);
      setEanValidated([false]);
    }
  }, [invoiceData]);

  const handleEanInputChange = (index, value) => {
    setEanInputs((prev) => {
      const arr = [...prev];
      arr[index] = value;
      return arr;
    });
    
    if (
      printType === "detalhada" &&
      invoiceData &&
      invoiceData.shipping &&
      Array.isArray(invoiceData.shipping.items_gtin)
    ) {
      const expectedEan = invoiceData.shipping.items_gtin[index]?.gtin_code;
      setEanValidated((prev) => {
        const arr = [...prev];
        if (expectedEan && value.trim() === expectedEan) {
          arr[index] = true;
          playBeep(1200, 0.2, "success");
        } else {
          arr[index] = false;
          playBeep(200, 0.3, "error");
        }
        return arr;
      });
    }
  };

  const resetEans = () => {
    setEanInputs(Array.isArray(eanInputs) ? eanInputs.map(() => "") : [""]);
    setEanValidated(Array.isArray(eanValidated) ? eanValidated.map(() => false) : [false]);
  };

  return {
    eanInputs,
    eanValidated,
    handleEanInputChange,
    resetEans,
  };
};